// Two of these you can actually open and use; the rest are described. Nothing
// here links out until there is something real on the other end of the link.

export const LIVE = [
  {
    title: 'Subaru Baja Configurator',
    year: '2025',
    to: '/baja',
    action: 'Open the configurator',
    image: '/images/card-baja.jpg',
    summary:
      'A real-time 3D configurator for the 2003–2006 Baja, built on three.js. Every '
      + 'factory paint combination is modelled from its actual colour codes by model '
      + 'year, with a custom mixer that saves your own finishes. The car drives, the '
      + 'lights switch, and the whole scene renders in the browser.',
    stack: ['three.js', 'WebGL', 'React', 'glTF', 'PBR materials'],
  },
  {
    title: 'The Darkroom',
    year: '2026',
    to: '/darkroom',
    action: 'Open the darkroom',
    image: '/images/card-darkroom.jpg',
    summary:
      'Three rolls of 35mm black and white as working contact sheets. A beaded pull '
      + 'chain drops the room to safelight, which flips the sheets back to negatives; '
      + 'hovering a frame strikes the enlarger lamp. Scans are processed down from '
      + '245MB of originals to 23MB of layered web assets.',
    stack: ['React', 'CSS filters', 'Pointer events', 'Image pipeline'],
  },
];

export const WORK = [
  {
    title: 'Demographic Drug Prediction Model',
    year: '2024',
    summary:
      'A machine learning model predicting future drug trends from CDC data at 97% '
      + 'accuracy, paired with an interactive dashboard built for public health '
      + 'decision-making rather than for other data scientists.',
    stack: ['Python', 'Scikit-learn', 'CDC datasets', 'Dashboarding'],
  },
  {
    title: 'Landslide Volume Prediction',
    year: '2023',
    summary:
      'Neural network predicting landslide volumes across the Pacific Northwest, with '
      + 'the 2024 projections rendered as geographic visualisations in ArcGIS.',
    stack: ['Python', 'Scikit-learn', 'Neural networks', 'ArcGIS'],
  },
  {
    title: 'SUB UW — Student Subletting',
    year: '2025',
    summary:
      'A subletting platform scoped to University of Washington students, with '
      + 'two-factor authentication and live database connectivity.',
    stack: ['React', 'SQL Server', 'Azure Data Studio', '2FA'],
  },
  {
    title: 'WineAbout — Cellar Management',
    year: '2025',
    summary:
      'Contracted MVP for a wine cellar application. Prototyped and user-tested in '
      + 'Figma, then built in SwiftUI against a SQL Server backend.',
    stack: ['SwiftUI', 'SQL Server', 'Figma', 'User testing'],
  },
  {
    title: 'Analog Club UW — Site & Gallery',
    year: '2024',
    summary:
      'A digital gallery and event system for a 200+ member photography club, on '
      + 'Firebase with Google Calendar integration for scheduling.',
    stack: ['React', 'Firebase', 'Google Calendar API'],
  },
  {
    title: 'Rethink UW — Sustainability Platform',
    year: '2023',
    summary:
      'A directory recommending sustainable organisations around Seattle, with a '
      + 'real-time MySQL backend and an admin portal for curation.',
    stack: ['Java', 'Python', 'Node.js', 'MySQL'],
  },
];

export const SKILLS = [
  { label: 'Languages', items: ['Python', 'JavaScript', 'TypeScript', 'Java', 'C/C++', 'SQL', 'Swift'] },
  { label: 'Data & ML', items: ['Scikit-learn', 'Pandas', 'Tableau', 'Power BI', 'ArcGIS'] },
  { label: 'Building', items: ['React', 'Node.js', 'three.js', 'SwiftUI', 'Figma'] },
  { label: 'Data stores', items: ['SQL Server', 'MySQL', 'MongoDB', 'Firebase', 'SQLite'] },
  { label: 'Practice', items: ['Data pipelines', 'Dashboarding', 'Agile', 'Team leadership'] },
];

export const EXPERIENCE = [
  {
    role: 'Software Engineer',
    org: 'Hackerant Industries',
    place: 'Redmond, WA',
    when: '2025 — present',
    note: 'Building and shipping product end to end at a small startup.',
    current: true,
  },
  {
    role: 'Data Analyst',
    org: 'Seattle City Light — Strategy',
    place: 'Seattle, WA',
    when: '2024 — 2025',
    note:
      'Built Python pipelines with sentiment detection that took survey engagement '
      + 'from 20% to 40%, and Tableau dashboards over 400,000+ customer records that '
      + 'lifted rebate participation by 30%.',
  },
  {
    role: 'Software Engineer, contract',
    org: 'WineAbout',
    place: 'Redmond, WA',
    when: '2025',
    note: 'Prototyped, tested and shipped an MVP cellar application in SwiftUI.',
  },
  {
    role: 'Founder & President',
    org: 'Analog Club UW',
    place: 'Seattle, WA',
    when: '2024 — 2025',
    note:
      'Grew an analog photography club to 200+ members, ran four teams totalling 54 '
      + 'people, raised $2,000+ and produced a 100-page magazine.',
  },
  {
    role: 'Software Engineering Intern',
    org: 'BraveSoft Inc',
    place: 'Ann Arbor, MI',
    when: '2023 — 2024',
    note:
      'Power BI and Python dashboards, plus a compensation analysis in MySQL and '
      + 'Pandas that surfaced pay inequality at client companies.',
  },
  {
    role: 'BS, Information Science & Data Science',
    org: 'University of Washington',
    place: 'Seattle, WA',
    when: '2021 — 2025',
    note: 'GPA 3.6. Algorithms, machine learning, databases, cooperative software engineering.',
  },
];

// A few frames off the contact sheets, as a way into the darkroom.
export const STRIP = [
  '2024-10-10-0013',
  '2024-10-10-0012',
  '2024-10-10-0018',
  '2026-01-07-0005',
  '2026-01-07-0015',
  '2026-01-08-0011',
];
